import { LangEnum } from '@/i18n.config'

type AddressContext = {
  area?: string
  address?: string
  full_address?: string
  lat?: number
  lng?: number
  google_place_id?: string
  locale_address?: string
}

export function useAddress(_data: MaybeRef<AddressContext | undefined>) {
  const data = computed(() => unref(_data))
  const i18n = useI18n()

  const fullAddress = computed(() => {
    if (data.value?.full_address) return data.value.full_address
    // fallback to area and address
    switch (i18n.locale.value as string) {
      case LangEnum.TW:
      case LangEnum.CN:
      case LangEnum.JP:
        return `${data.value?.area}${data.value?.address}`
      case LangEnum.THAI:
        return `${data.value?.address} ${data.value?.area}`
      default:
        return `${data.value?.address}, ${data.value?.area}`
    }
  })

  const googleMapAddressQueryString = computed(() => {
    if (data.value?.google_place_id) {
      return `place_id:${data.value.google_place_id}`
    }
    return data.value?.locale_address || fullAddress.value
  })

  return {
    fullAddress,
    googleMapAddressQueryString,
  }
}
